import { Fade } from "react-awesome-reveal";
import { useLoader } from "../../context/LoaderContext";
import { IMemberListData, INewsLetterData } from "../../exports/interfaces";
import DynamicToolTip from "../DynamicToolTip";
import { useUserDataContext } from "../../context/UserDataContext";

const AllNewsLetter = (props: {
  newsLetterData: INewsLetterData[];
  matchedMember: IMemberListData | undefined;
}) => {
  const { loading } = useLoader();
  const { userData } = useUserDataContext();
  const newsletters = userData?.data?.roles?.some( 
    (r: { name: string }) => r?.name === "sa"
  )
    ? props.newsLetterData
    : props?.matchedMember?.attributes?.Type_Of_Membership?.toLowerCase()?.replace(
        /\s/g,
        ""
      ) === "associatemembership" &&
      props?.matchedMember?.attributes?.Status === "Active"
    ? props.newsLetterData?.filter(
        (newsLetter) =>
          newsLetter?.attributes?.View_To_All ||
          newsLetter?.attributes?.Associate_Membership
      )
    : props?.matchedMember?.attributes?.Type_Of_Membership?.toLowerCase()?.replace(
        /\s/g,
        ""
      ) === "one-timemembership" &&
      props?.matchedMember?.attributes?.Status === "Active"
    ? props.newsLetterData?.filter(
        (newsLetter) =>
          newsLetter?.attributes?.View_To_All ||
          newsLetter?.attributes?.One_Time_Membership
      )
    : props?.matchedMember?.attributes?.Type_Of_Membership?.toLowerCase()?.replace(
        /\s/g,
        ""
      ) === "corporatemembership" &&
      props?.matchedMember?.attributes?.Status === "Active"
    ? props.newsLetterData?.filter(
        (newsLetter) =>
          newsLetter?.attributes?.View_To_All ||
          newsLetter?.attributes?.Corporate_Membership
      )
    : props?.newsLetterData?.filter(
        (newsLetter) => newsLetter?.attributes?.View_To_All
      );

  return (
    <section className="events-page custom-padding">
      <div className="container">
        <div className="row" style={{ justifyContent: "center" }}>
          {!loading &&
            newsletters?.map((news, index) => (
              <div className="col-5th custom-margin-bottom" key={news.id}>
                <Fade
                  key={index}
                  cascade
                  damping={0.2}
                  triggerOnce={true}
                  delay={index * 200}
                >
                  <div className="events__single">
                    <div className="events__img">
                      <img
                        src={news?.attributes?.Image?.data?.attributes?.url && `${process.env.REACT_APP_strapiUrl}${news?.attributes?.Image?.data?.attributes?.url}`}
                        alt="newsletter-image"
                        className="row-image"
                        style={{
                          objectFit: "cover",
                        }}
                      />
                      {/* <div className="events__date">
                    <p>{event?.attributes?.Date}</p>
                  </div> */}
                    </div>
                    <div className="events__content row-content">
                      <h3
                        className="events__title text-truncate custom-grid-font-size"
                        style={{ marginBottom: "5px" }}
                      >
                        {/* <Link
                      to="/events/events-details"
                      state={{
                        id: event.id,
                        bannerUrl: props?.eventBannerImage
                      }}
                    > */}
                        <DynamicToolTip title={news?.attributes?.Name}>
                          {news?.attributes?.Name}
                        </DynamicToolTip>
                        {/* </Link> */}
                      </h3>
                      {/* <ul className="list-unstyled events__meta"> */}
                      {/* <li>
                      <i className="far fa-clock"></i>
                      {event?.attributes?.Time}
                    </li>
                    <li>
                      <i className="fas fa-map-marker-alt"></i>
                      {event?.attributes?.Event_Location}
                    </li> */}
                      <div className="custom-newsletter-button">
                        <a
                          href={`${process.env.REACT_APP_strapiUrl}${news?.attributes?.File?.data?.attributes?.url}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="thm-btn main-header-two__btn custom-main-header-two__btn custom-donate-btn"
                        >
                          {" "}
                          {/* <i className="fa fa-heart"></i>  */}
                          View
                        </a>
                      </div>
                      {/* </ul> */}
                    </div>
                  </div>
                </Fade>
              </div>
            ))}
        </div>
      </div>
    </section>
  );
};

export default AllNewsLetter;
